export default __webpack_public_path__ + "static/media/work-portfolio-img4.88993426.png";